  import React from "react";
import { rulesApplyFiftyPercentDiscount } from "../../../shared/services";
import { notify } from "@/shared/utils/notify";
import { Iproducts2x1 } from "../../../redux/@types";

export const useUpdateStatusRulesSushiLunch = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const updateStatus = async(value: "active" | "inactive", id: any) =>{
    if (isLoading) return;
    setIsLoading(true);
    await rulesApplyFiftyPercentDiscount.patch(id,{
      status: value,
    })
    .then((res: Partial<Iproducts2x1>) => {
      setIsLoading(false);
        notify.success(
          `Se ha actualizado con éxito el estado del producto gratis con id:${res.id}`
        );
    })
    .catch((err: any) => {
      setIsLoading(false);
      notify.error(err.message);
    });
  }

  return {
    isLoading,
    updateStatus
  };
};
